module.exports = __webpack_public_path__ + "static/media/lincoln-bumper_selected.e6dd4c6a.svg";